import randomName from '@scaleway/random-name';
export { default as randomName } from '@scaleway/random-name';
import { useCallback } from 'react';

const useRandomName = function () {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  return useCallback(() => randomName(prefix, separator), [prefix, separator])();
};

export { useRandomName as default };
